/**
* Progress JS
* -----------------------------------------------------------------------------
*
* All the JS for the Progress component.
*/

/*
 * Example of importing modules if needed. Like for scroll magic / gsap
 */

// import {gsap} from 'gsap';
// import {ScrollTrigger} from 'gsap/ScrollTrigger.js';
// gsap.registerPlugin( ScrollTrigger );
import Splide from '@splidejs/splide';
// import {AutoScroll} from '@splidejs/splide-extension-auto-scroll';
( function( app ) {
  const COMPONENT = {

    className: 'progress',
    selector: function() {
      return '.' + this.className;
    },
    // Fires after common.init, before .finalize and common.finalize
    init: function() {
      if ( $( '.progress-slider-nav' ).length ) {
        $( '.progress-slider-nav' ).each( function( index, element ) {
          const navSlider = new Splide( element, {
            type: 'slide',
            perPage: 5,
            fixedWidth: false,
            gap: '4px',
            perMove: 1,
            arrows: false,
            pagination: false,
            drag: true,
            breakpoints: {
              1024: {
                fixedWidth: '220px',
                focus: 'center',
              },
            },
          } );

          const mainSliderContainer = $( element ).closest( '.component-spacing' ).find( '.progress-slider-main' );
          if ( mainSliderContainer.length ) {
            const mainSlider = new Splide( mainSliderContainer[0], {
              type: 'fade',
              rewind: true,
              perPage: 1,
              perMove: 1,
              arrows: false,
              pagination: false,
              autoplay: 'play',
              breakpoints: {
                1024: {
                  arrows: true,
                },
              },
            } );
            $( '.progress-splide-to' ).on( 'click', function() {
              const splideIndex = $( this ).data( 'slide' );
              mainSlider.go( splideIndex );
              $( '.progress-splide-to' ).removeClass( 'is-active' );
              $( this ).addClass( 'is-active' );
            } );

            mainSlider.on( 'move', function( newIndex, prevIndex, destIndex ) {
              $( '.progress-splide-to' ).each( function() {
                if ( $( this ).data( 'slide' ) !== newIndex ) {
                  $( this ).removeClass( 'is-active' );
                } else {
                  $( this ).addClass( 'is-active' );
                }
              } );
            } );

            mainSlider.sync( navSlider );
            navSlider.mount( );
            mainSlider.mount( );
          }
        } );
      }
    },
    finalize: function() {
    },
  };

  // Hooks the component into the app
  app.registerComponent( 'progress', COMPONENT );
} )( app );
